import CSS from 'csstype';
import React from 'react';

import {
  SimpleTextToggleSize,
  simpleTextToggleSizeStyle,
} from '~/src/dash/components/toggles/common';
import { publicaColors } from '~/src/dash/utils/colors';

interface IMobileThemedToggleProps {
  active: boolean;
  children?: any;
  className?: string;
  disabled?: boolean;
  onClick: (props?: any | null) => void;
  size?: SimpleTextToggleSize;
  small?: boolean;
  style?: CSS.Properties;
  value?: string; // using this will nullify children
}

// TODO: V2 WE WILL ADD DYNAMIC THEME COLOR SWITCHING. FOR NOW THIS FORCES THE PUBLICA COLOR THEME.
export const MobileThemedToggle = ({
  active,
  children,
  className = '',
  disabled,
  onClick,
  style,
  value,
  size = 'base',
}: IMobileThemedToggleProps) => {
  // const { theme } = usePanel();

  return (
    <button
      onClick={disabled ? () => null : onClick}
      className={className}
      style={{
        display: 'inline-block',
        borderWidth: 0,
        lineHeight: 'inherit',
        fontFamily: 'inherit',
        fontStyle: 'inherit',
        whiteSpace: 'nowrap',
        margin: 0,
        backgroundColor: active ? publicaColors.blue : publicaColors.lightGray,
        color: active ? publicaColors.white : publicaColors.black,
        opacity: disabled ? 0.4 : 1,
        cursor: disabled ? 'not-allowed' : 'pointer',
        minWidth: '40px',
        textAlign: 'center',
        ...simpleTextToggleSizeStyle(size),
        ...style,
      }}
    >
      {value || children}
    </button>
  );
};
